var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "card--icon h-100 pa-20 pa-md-30 py-lg-44 px-lg-40",
    attrs: {
      "href": _vm.link
    }
  }, [_c('div', {
    staticClass: "mb-18 mb-lg-38"
  }, [_c('h4', {
    staticClass: "tit--sm"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" " + _vm._s(_vm.sc) + " ")])]), _c('div', {
    staticClass: "d-flex justify-end"
  }, [_c('v-img', {
    attrs: {
      "src": _vm.icon,
      "max-width": "192"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }